import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	HostBinding,
	OnDestroy,
	OnInit,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { CommonState, VerificationType } from "@obg/ngx.common";
import { CustomerManagementSelector } from "@obg/ngx.core";
import { RouteAction, RouteSelector } from "@obg/ngx.router";
import { ignoreNil } from "@obg/rxjs";
import { Subscription } from "rxjs";
import { filter, tap, withLatestFrom } from "rxjs/operators";

import { DialogRouteConfig, RegisterSuccessQueryParams } from "./customer-verification.model";

@Component({
	selector: "obg-m-customer-verification-step-container",
	styleUrls: ["./customer-verification-step.container.scss"],
	templateUrl: "./customer-verification-step.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class CustomerVerificationStepContainer implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-customer-verification-step") hostClass = true;

	@Output() nextStep = new EventEmitter();
	name: string | undefined;
	username: string | undefined;
	welcomeMessage: string | undefined;
	variant: VerificationType | undefined;

	private data$$: Subscription | undefined;

	constructor(
		private store: Store<CommonState>,
		private matDialog: MatDialog,
		private changeDetector: ChangeDetectorRef
	) {}

	ngOnInit() {
		const params$ = this.store.select<RegisterSuccessQueryParams | undefined>(RouteSelector.getQueryParams).pipe(
			ignoreNil(),
			filter((params) => !!params.variant),
			withLatestFrom(this.store.select(CustomerManagementSelector.getCustomer)),
			tap(([params, customer]) => {
				this.name = customer?.profile?.firstName;
				this.variant = params.variant;
				this.username = params.username;
				this.welcomeMessage = this.name
					? "customer-verification.customer-welcome"
					: "customer-verification.welcome";
				this.store.dispatch(
					RouteAction.updateQueryParams({
						name: null,
						username: null,
						variant: null,
					})
				);
				this.changeDetector.detectChanges();
			})
		);

		this.data$$ = params$.subscribe();
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}

	navigateToNextStep(dismiss: DialogRouteConfig | undefined) {
		if (!dismiss) {
			return this.matDialog.closeAll();
		}
		this.nextStep.emit();
	}
}
